import { Brand, FontFamily, PartialTheme } from 'even-ts-static'

import { getBrandObject } from 'embed/utils'
import { brandFromHost } from 'embed/constants/config'

export const DEFAULT_THEME: PartialTheme = {
  ...getBrandObject(brandFromHost).defaultTheme,
  ...(brandFromHost === Brand.Even
    ? {
        backdropStyles: { backgroundColor: '#f5f9ff', padding: '16px 10px 0 10px' },
        colorBackgroundSecondary: '#f8f7fc',
        colorPrimary: '#66a9f4',
        colorSecondary: '#66a9f4',
        ctaStyles: { backgroundColor: '#36d386' },
        errorStyles: { color: '#e69575' },
        fontFamilyPrimary: FontFamily.OpenSans,
        headlineStyles: { fontFamily: FontFamily.OpenSans },
      }
    : brandFromHost === Brand.Fiona
    ? {
        backdropStyles: { backgroundColor: '#f8f2ff', padding: '16px 10px 0 10px' },
        colorBackgroundSecondary: '#f4f4f4',
        colorPrimary: '#3b1c5a',
        colorSecondary: '#ff7200',
        ctaStyles: { backgroundColor: '#14e075' },
        errorStyles: { color: '#ff7200' },
        fontFamilyPrimary: FontFamily.Nunito,
        fontFamilySecondary: FontFamily.Nunito,
        headlineStyles: { fontFamily: FontFamily.Nunito },
      }
    : { backdropStyles: { backgroundColor: '#f4fff9', padding: '16px 10px 0 10px' } }),
}
